import { LitEntity, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-placeholder';

export const FIRMWARE_MODE = {
  FACTORY: '0',
  SETUP: '1',
  RUN: '2',
};

class DeviceFirmwareMode extends LitEntity {
  static get properties() {
    return {
      desired: { type: Boolean },
    };
  }

  static get styles() {
    return sharedStyles;
  }

  render() {
    if (!this.entity) {
      return html`<bn-placeholder></bn-placeholder>`;
    }
    const mode = this.getProperty(`firmwareMode.${this.desired ? 'desired' : 'reported'}`);
    return html`${this._modeText(mode)} (${mode})`;
  }

  _modeText(mode) {
    switch (mode) {
    case FIRMWARE_MODE.FACTORY:
      return 'Factory';
    case FIRMWARE_MODE.SETUP:
      return 'Setup';
    case FIRMWARE_MODE.RUN:
      return 'Run';
    }
    return 'Unknown';
  }
}

window.customElements.define('device-firmware-mode', DeviceFirmwareMode);
